import React from 'react'
import './Features.scss'
import {graphql} from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import checkmark from '../../assets/svg/checkmark.svg'
import Link from '../Link/Link'

const Table = ({text, title, titleMobile, logo, table, side}) => {
	return(
		<div className={`Table ${side}`}>
			<div className="content">
				{ logo && <div className="logo"><GatsbyImage image={getImage(logo.localFile.childImageSharp)} alt={logo.altText} /></div> }
				{ title ? <h3 className="title" dangerouslySetInnerHTML={{__html: title}} /> : null }
				{ titleMobile ? <h3 className="title-mobile" dangerouslySetInnerHTML={{__html: titleMobile}} /> : null }
				{ text ? <div className="text" dangerouslySetInnerHTML={{__html: text}} /> : null }
			</div>
			<hr />
			<table>
				<thead>
					<tr>
						<th>Inkludert</th>
						<th>Funksjon</th>
					</tr>
				</thead>
				<tbody>
					{
						table && table.map((row,i) =>
							<tr key={i} className={`active`}>
								<td className="included">
									<img src={checkmark} alt="inkludert" />
								</td>
								<td className="feature">
									<p>{row.text}</p>
								</td>
							</tr>)
					}
				</tbody>
			</table>
			{
				side === 'left' &&
				<div className="left-content">
					<ul>
						<li>
							<Link url="/prov-gratis" title="Prøv gratis i 30 dager" type="arrow" />
						</li>
						<li>
							<Link url="/fordelene-med-lovdata-pro" title="Fortell meg om alle fordelene" type="arrow" />
						</li>
						<li>
							<Link url="/sporsmal-og-svar" title="Se ofte stilte spørsmål" type="arrow" />
						</li>
					</ul>
					<p>Ikke helt overbevist? <a href="mailto:marked@lovdata.no">Ta gjerne kontakt her</a> hvis du lurer på noe.</p>
				</div>
			}
		</div>
	)
}

export default function Features({left, right}) {
	return(
		<div className="Features">
			<div className="tables">
				<Table {...left} side="left" />
				<Table {...right} side="right" />
			</div>
		</div>
	)
}

export const query = graphql`
	fragment Features on WpPage_Layout_block_Layout_Features {
		fieldGroupName
		left {
			text
			title
			titleMobile
			logo {
				altText
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 200,
							backgroundColor: "transparent",
							quality: 100,

						)
					}
				}
			}
			table {
				text
			}
		}
		right {
			text
			title
			titleMobile
			logo {
				altText
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 200,
							backgroundColor: "transparent",
							quality: 100,
						)
					}
				}
			}
			table {
				text
			}
		}
	}
`